import React, { useRef, useState, useEffect } from 'react';
import Axios from 'axios';
import Link from '../Link';

import "./index.scss";


const DetailPageLayout = ({ backLink, children, className, ...props }) => {
    const wrapper = useRef(null);
    const [headerMinimal, setHeaderMinimal] = useState(false);

    useEffect(() => {
        if (!wrapper.current) return;
        window.addEventListener('scroll', handleWatchScroll);
        handleLazyLoad();
        return () => {
            window.removeEventListener('scroll', handleWatchScroll);
            delete window.projectPrevScrollpos;
        };
    }, []);

    const handleWatchScroll = () => {
        handleHeaderMinmal();
        handleLazyLoad();
    };

    const handleHeaderMinmal = () => {
        const currentScrollPos = window.pageYOffset;
        const currentHeaderMinmal = window.projectPrevScrollpos < currentScrollPos;
        window.projectPrevScrollpos = currentScrollPos;
        setHeaderMinimal(currentHeaderMinmal);
    }

    const handleLazyLoad = () => {
        const lazyItems = wrapper.current.querySelectorAll('.lazy');
        lazyItems.forEach(lazy => {
            const pos = lazy.getBoundingClientRect();
            if (pos.y - window.innerHeight < 0 && !lazy.classList.contains('-finish')) {
                lazy.classList.add('-start');
                Axios.get(lazy.dataset.lazy)
                    .then(res => {
                        setTimeout(() => {
                            lazy.classList.remove('-start');
                            lazy.classList.add('-finish');
                            lazy.querySelector('img').setAttribute('src', lazy.dataset.lazy)
                            lazy.dataset.lazy
                        }, 600);
                    })
            };
        });
    }

    return (
        <div className={className} ref={wrapper} {...props}>
            <div className={`page__header ${headerMinimal ? '-min' : ''} `}>
                <div className="header">
                    <div className="container">
                        <Link className="back" to={backLink}>
                            <i className="icon-arrow-left"></i>
                            <span className="type-heading -h5 -en">BACK</span>
                        </Link>
                    </div>
                </div>
            </div>
            {children}
        </div>
    )
}

export default DetailPageLayout;